import { filterBy, orderBy } from "@progress/kendo-data-query";
import { clone } from "@progress/kendo-react-common";
import { Grid } from "@progress/kendo-react-grid";
import { GridHelper } from "../../Utilities/GridHelper";
import {
  DataConnectionPreviewData,
  selectedDataConnectionColumns,
  selectedDataConnectionGridFilter,
  selectedDataConnectionGridSort,
  selectedDataConnectionItem,
  templateData,
} from "../NewTemplateSignals";

export const DataConnectionPreview = () => {
  return (
    <div>
      <GridHelper
        toolbarSettings={{
          filterHighlights: false,
          expandCollapseAllButton: false,
          pdfExportButton: false,
          excelExportButton: false,
          externalFilter: false,
          showFeaturesConfigurator: false,
          showColumnsConfigurator: true,
        }}
        filterable={false}
        dataItemKey={"id"}
        selectable={false}
        groupable={false}
        sortable={false}
        data={orderBy(
          filterBy(DataConnectionPreviewData.value, selectedDataConnectionGridFilter.value),
          selectedDataConnectionGridSort.value
        )}
        item={selectedDataConnectionItem.value}
      >
        <Grid
          style={{ height: "100%" }}
          dataItemKey="id"
          sort={selectedDataConnectionGridSort?.value || []}
          filter={selectedDataConnectionGridFilter.value}
          sortable={true}
          onFilterChange={(e) => {
            templateData.value = {
              ...templateData.value,
              properties: {
                ...templateData.value.properties,
                DataConnections: templateData.value.properties.DataConnections.map((item) =>
                  item.id === selectedDataConnectionItem.value.id
                    ? { ...item, filter: e.filter }
                    : item
                ),
              },
            };
            const tempTemplateData = {
              ...templateData.value,
              sections: templateData.value.sections.map((section) => ({
                ...section,
                fields: section.fields.map((field) => {
                  if (field.properties?.Data?.id === selectedDataConnectionItem.value.id) {
                    return {
                      ...field,
                      properties: {
                        ...field.properties,
                        Data: clone(
                          templateData.value.properties.DataConnections.find(
                            (dc) => dc.id === selectedDataConnectionItem.value.id
                          )
                        ),
                      },
                    };
                  }
                  return field;
                }),
              })),
            };

            templateData.value = tempTemplateData;
          }}
          onSortChange={(e) => {
            templateData.value = {
              ...templateData.value,
              properties: {
                ...templateData.value.properties,
                DataConnections: templateData.value.properties.DataConnections.map((item) => {
                  if (item.id === selectedDataConnectionItem.value.id) {
                    const newSort = e.sort[0]; // Assuming e.sort is an array and you're interested in the first sort descriptor
                    let updatedSortDescriptors = item.sort ? [...item.sort] : [];

                    const existingSortIndex = updatedSortDescriptors.findIndex(
                      (sd) => sd.field === newSort.field
                    );
                    if (existingSortIndex !== -1) {
                      // Update existing descriptor
                      updatedSortDescriptors[existingSortIndex] = newSort;
                    } else {
                      // Add new descriptor
                      updatedSortDescriptors.push(newSort);
                    }

                    return { ...item, sort: updatedSortDescriptors };
                  }

                  return item;
                }),
              },
            };
            const tempTemplateData = {
              ...templateData.value,
              sections: templateData.value.sections.map((section) => ({
                ...section,
                fields: section.fields.map((field) => {
                  if (field.properties?.Data?.id === selectedDataConnectionItem.value.id) {
                    return {
                      ...field,
                      properties: {
                        ...field.properties,
                        Data: clone(
                          templateData.value.properties.DataConnections.find(
                            (dc) => dc.id === selectedDataConnectionItem.value.id
                          )
                        ),
                      },
                    };
                  }
                  return field;
                }),
              })),
            };

            templateData.value = tempTemplateData;
          }}
        >
          {selectedDataConnectionColumns.value.map((column) => column)}
        </Grid>
      </GridHelper>
    </div>
  );
};
